import { useEffect } from 'react';
import { io } from 'socket.io-client';

interface PreAuthorizationNotificationData {
    id?: number;
    cpiId?: string;
    kioskId?: number;
    storeId?: number;
    storeLabel?: string;
    kioskLabel?: string;
    preAuthorizationAmount?: number;
    cpiCreatedAt?: string;
    createdAt?: string;
    [key: string]: unknown;
}

export const usePreAuthorizationNotifications = (
    onPreAuthorization?: (data: PreAuthorizationNotificationData) => void
) => {
    useEffect(() => {
        const url = import.meta.env.VITE_BACKEND_API_ENDPOINT || 'http://localhost:3333';

        const socket = io(url, {
            transports: ['websocket', 'polling'],
            autoConnect: true,
            timeout: 60000,
            reconnection: true,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 10000,
            reconnectionAttempts: 10,
            forceNew: false,
            upgrade: true,
            rememberUpgrade: true,
        });

        socket.on('connect_error', (error) => {
            console.error('[WebSocket] Pre-authorization connection error:', error);
        });

        socket.on('new-pre-authorization', (data: PreAuthorizationNotificationData) => {
            if (onPreAuthorization) {
                onPreAuthorization(data);
            }
        });

        socket.on('pre-authorization-updated', (data: PreAuthorizationNotificationData) => {
            if (onPreAuthorization) {
                onPreAuthorization(data);
            }
        });

        return () => {
            socket.disconnect();
        };
    }, [onPreAuthorization]);
};
